<template>
	<div class="pb-3 bg-white rounded-cus cus-box-shadow shop-cart">
		<div class="col-12 pl-0 pr-0">
			<div class="col-12 pt-3 pl-2 pr-2 d-flex">
				<div class="col-8 pl-0 mt-auto mb-auto font-size-12 font-size-sm-11">Keranjang Belanja</div>
				<div class="col-4 rounded-pill bg-blue font-size-10 color-white m-auto pt-1 pb-1 text-center">{{total_cart}} Item</div>
			</div>
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-bottom"></div>
			</div>
		</div>
		<div class="col-12 pl-0 pr-0 font-size-11 color-gray-2 shop-cart-item" id="shop-cart-container">
			<div class="col-12 pl-0 pr-0 d-flex flex-wrap justify-content-center" v-if="cart.length < 1">
				<div class="col-6 col-md-12 pl-0 pr-0 pt-4 text-center">
					<img class="img-fluid" src="/assets/transaction/keranjang-belanja-kosong.png">
				</div>
				<div class="col-12 pl-0 pr-0 text-center pt-2 font-size-sm-10">Keranjang Belanja Anda masih kosong...</div>
			</div>
			<div class="col-12 pl-0 pr-0 text-center shop-cart-item" v-if="cart.length > 0">
				<div class="col-12 pl-2 pr-2 pt-3 d-flex" v-for="(value, index) in cartShow" :key="index">
					<div class="col-2 pl-0 mt-auto mb-auto"><img class="img-fluid" :src="value.product_image_filename"></div>
					<div class="col-9 pl-0 text-left">
						<div class="col-12 font-size-11 color-black">{{value.product_name}}</div>
						<div class="col-12 font-size-9 color-gray-2">{{value.product_price | toRupiah}}</div>
						<div v-if="step == 0 && mitra && !register" class="col-12 pt-1 d-flex justify-content-start">
							<button @click="minQty(index)" class="btn p-0 color-blue no-box-focus btn-hover mr-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-minus-circle"></i></span>
							</button>
							<input @keypress="onlyNumber" @paste.prevent v-model="value.quantity" @change="cekQty(index)" type="text" class="col-4 form-control form-control-sm font-size-9 font-weight-bold no-box-focus text-center">
							<button @click="addQty(index)" class="btn p-0 color-blue no-box-focus btn-hover ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-plus-circle"></i></span>
							</button>
						</div>
						<div v-if="step == 0 && !mitra && !register" class="col-12 pt-1 d-flex justify-content-start">
							<button @click="minQty(index)" class="btn p-0 color-blue no-box-focus btn-hover mr-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-minus-circle"></i></span>
							</button>
							<input @keypress="onlyNumber" @paste.prevent v-model="value.quantity" @change="cekQty(index)" type="text" class="col-4 form-control form-control-sm font-size-9 font-weight-bold no-box-focus text-center">
							<button @click="addQty(index)" class="btn p-0 color-blue ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-plus-circle"></i></span>
							</button>
						</div>
						<div v-if="step == 0 && register" class="col-12 pt-1 d-flex justify-content-start">
							<button @click="minQty(index)" class="btn p-0 color-blue no-box-focus btn-hover mr-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-minus-circle"></i></span>
							</button>
							<input @keypress="onlyNumber" @paste.prevent v-model="value.quantity" @change="cekQty(index)" type="text" class="col-4 form-control form-control-sm font-size-9 font-weight-bold no-box-focus text-center">
							<button @click="addQty(index)" class="btn p-0 color-blue ml-2 mt-n1">
								<span class="font-size-16"><i class="fas fa-plus-circle"></i></span>
							</button>
						</div>
					</div>
					<div class="col-1 text-right mt-auto mb-auto" v-if="mitra || register">
						<span @click="deleteCart(value.product_id)" v-show="step == 0" class="cursor-pointer color-red"><i class="fas fa-trash"></i></span>
						<span v-show="step > 0" class="">{{value.quantity}}</span>
					</div>
					<div class="col-1 text-right mt-auto mb-auto" v-if="!mitra">
						<span @click="deleteCart(value.product_id)" v-show="step == 0" class="cursor-pointer color-red"><i class="fas fa-trash"></i></span>
						<span v-show="step > 0" class="">{{value.quantity}}</span>
					</div>
				</div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 mt-3 font-size-11">
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-top"></div>
			</div>
			<div class="col-12 pl-2 pr-2 d-flex color-gray-2">
				<div class="col-6 pl-0">Subtotal</div>
				<div class="col-6 pr-0 text-right">{{price_total | toRupiah}}</div>
			</div>
			<div class="col-12 pl-2 pr-2 pt-2 d-flex color-gray-2" v-if="(!mitra || register) && Object.values(registerItem).length > 0">
				<div class="col-7 pl-0" v-html="registerItem.title.replace(/[(]/g, '<br>(')"></div>
				<div class="col-5 pr-0 text-right">{{ registerItem.price | toRupiah}}</div>
			</div>
			<div class="col-12 pl-2 pr-2">
				<div class="col-12 pt-3 border-bottom"></div>
			</div>
		</div>
		<div v-show="cart.length > 0" class="col-12 pl-0 pr-0 pb-5 pb-lg-0 mt-3 font-size-12">
			<div class="col-12 pl-2 pr-2 d-flex">
				<div class="col-6 pl-0">Total</div>
				<div v-if="mitra && !register" class="col-6 pr-0 text-right">{{price_total | toRupiah}}</div>
				<div v-if="!mitra || register" class="col-6 pr-0 text-right">{{price_total + (registerItem.price_total ? registerItem.price_total : 0) | toRupiah}}</div>
			</div>
		</div>
		<!-- <div class="col-12 pl-0 pr-0 btn-cart" v-if="step == 1">
			<button :disabled="cart.length == 0" class="col-12 btn bg-blue color-white no-box-focus" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div> -->
		<!-- STEP TRANSAKSI MITRA -->
		<div class="col-12 pl-0 pr-0" :class="[step < 2 ? 'btn-cart' : 'btn-cart-twin']" v-if="step >= 0 && step < 3 && mitra && !register">
			<button class="btn bg-red color-white no-box-focus" :class="[step == 1 ? 'col-12' : 'col-4']" @click="step_down" v-if="step > 0">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button v-if="step !== 1" :disabled="step == 0 && cart.length == 0" class="btn bg-blue color-white no-box-focus" :class="[step == 0 ? 'col-12' : 'col-8']" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>

		<!-- STEP TRANSAKSI MITRA BARU -->
		<div class="col-12 pl-0 pr-0" :class="[step < 1 ? 'btn-cart' : 'btn-cart-twin']" v-if="step < 3 && !mitra && !register">
			<button :disabled="cart.length == 0 || Object.values(registerItem).length == 0" v-if="step == 0" class="col-12 btn bg-blue color-white no-box-focus" @click="checkRegisterItem">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
			<button class="col-4 btn bg-red color-white no-box-focus" @click="step_down" v-if="step > 0">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button v-if="step > 0" class="col-8 btn bg-blue color-white no-box-focus" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>

		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step > 0 && step < 3 && register">
			<button class="col-4 btn bg-red color-white no-box-focus" @click="step_down" v-if="step > 0">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button :disabled="step == 1 && cart.length == 0" class="col-8 btn bg-blue color-white no-box-focus" @click="lanjut">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Selanjutnya</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>

		<!-- STEP PEMBAYARAN -->
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="(step == 3)">
			<button :disabled="progressBayar" class="col-4 btn bg-red color-white no-box-focus" @click="step_down">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-arrow-left mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Kembali</div>
				</div>
			</button>
			<button :disabled="progressBayar" class="col-8 btn bg-blue color-white no-box-focus" @click="confirmBayar">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">{{ progressBayar ? 'Sedang Diproses..': 'Bayar' }}</div>
					<i class="fas fa-arrow-right mt-1"></i>
				</div>
			</button>
		</div>

		<!-- STEP CETAK INVOICE -->
		<div class="col-12 pl-0 pr-0 btn-cart-twin" v-if="step == 4">
			<a :href="responsePaymentPdf" target="_blank" class="col-6 btn bg-light-blue color-white no-box-focus">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<i class="fas fa-print mt-1"></i>
					<div class="ml-2 font-size-11 font-weight-bold">Cetak Invoice</div>
				</div>
			</a>
			<button class="col-6 btn bg-blue color-white no-box-focus" @click="resetSemua">
				<div class="d-flex justify-content-center pt-1 pb-1">
					<div class="mr-2 font-size-11 font-weight-bold">Transaksi Kembali</div>
				</div>
			</button>
		</div>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions} from 'vuex';
import validator from 'validator';
export default {
	components: {
	},
	data() {
		return {
			kosong: false,
		}
	},
	props: {
		registrationData: {
			type: Object
		},
		alert: {
			type: Object
		}
	},
	computed: {
		...mapState('cart', ['step', 'cart', 'serialType', 'dataSerial', 'mitra', 'register',  'alertKeranjang', 'confirmPaymentMessage', 'selectedPayment', 'payTotal', 'progressBayar', 'registerItem', 'responsePaymentPdf', 'dataProduk', 'serialOptionName', 'serialDigitalAvailable', 'serialDigitalToSell']),
		...mapState('commonList', ['mitraMLM', 'mandatoryError','prospectiveMitra']),
		...mapState('auth', ['userData']),

		total_cart(){
			if(this.cart){
				return this.cart.length
			}
			return 0;
		},
		price_total(){
			let price_total = 0
			if(this.cart){
				this.cart.forEach(el => {
					price_total += parseInt(el.product_price) * parseInt(el.quantity)
				});
			}
			return price_total;
		},
		dataProduct() {
			var product = this.cart.map( (el) => {
				let obj = {
					product_code: el.product_code,
					product_id: el.product_id,
					product_name: el.product_name,
					product_price: el.product_price,
					product_weight: el.product_weight,
					product_unit: el.product_unit,
					quantity: el.quantity,
					product_bv: el.product_bv,
				}

				obj.serial_type = this.serialType

        obj.serial = []
        let serialNeeded = JSON.parse(el.product_is_serial)
				if (serialNeeded) {
          serialNeeded.forEach(isSerialEl => {
            let indexSerial = this.dataSerial.findIndex(element => element.product_code == el.product_code && element.type == isSerialEl.type_id)
            obj.serial[isSerialEl.type_id] = this.dataSerial[indexSerial].serial
          })
				}
				return obj
			})
			return product
		},
		cartShow() {
			return this.cart.filter((el) => {
				return el.quantity > 0
			})
		}
	},
	methods: {
		...mapMutations('cart', ['step_up', 'step_down', 'setAlertKeranjang', 'setConfirmPaymentMessage', 'reset', 'setShowModalPin']),
		...mapActions('cart', ['changeCartQty', 'deleteCart', 'postTransactionMitra', 'postTransactionNonMitra', 'postTransactionRegister']),
		...mapMutations('commonList', ['setAlertMandatory']),
		...mapActions('commonList', ['checkMandatory', 'getmitraMLM']),

		resetSemua(){
			if (this.register) {
				this.registrationData.mitra_code = ''
				this.registrationData.email = ''
				this.registrationData.name = ''
				this.registrationData.mobilephone = ''
			} else if (!this.mitra) {
				this.registrationData.mitra_code =  ''
				this.registrationData.email =  ''
				this.registrationData.name =  ''
				this.registrationData.card_id =  ''
				this.registrationData.mobilephone =  ''
			}
			this.reset()
		},
		checkRegisterItem() {
			/*cek jumlah produk register di produk apakah cart register + 1 cukup dengan sisa stock*/

			let registerProduct = this.dataProduk.find(element => element.product_code == this.registerItem.code)
			let registerInCart = this.cart.find(element => element.product_code == this.registerItem.code)
			let quantityRegister = registerInCart ? registerInCart.quantity : 0
			if ((registerProduct.stock_pos - quantityRegister) >= 0) {
				this.step_up()
			} else {
				this.setAlertKeranjang(`Silahkan melakukan penambahan produk ${this.registerItem.name}`)
			}
		},
		lanjut(){
			if (this.step == 0 || this.step == 1) {
				if (!this.register) {
					if (this.mitra) {
						this.validateCart()
					} else {
						this.validateData().then( () => {
							var filter = Object.values(this.alert).filter((el)=>{
								return el != ""
							})
							if (filter.length == 0) {
								this.step_up()
							}
						})
					}
				} else {
					this.validateCart()
				}
			} else if (this.step == 2) {
				if (this.userData.stockist_trx_method !== 'system') {
					this.setAlertKeranjang(`Silakan beralih menggunakan Metode Transaksi Sistem untuk melanjutkan transaksi`)
				} else {
					if(this.serialType == 2) {
						if (this.serialDigitalToSell > this.serialDigitalAvailable) {
							this.setAlertKeranjang(`Serial Digital yang Anda miliki tidak cukup untuk transaksi ini`)
						} else {
							this.step_up()
						}
					} else if (this.dataSerial.length > 0) {
						this.dataSerial.forEach( (element, index) => {
							if (element.max_qty != element.serial.length) {
								this.setAlertKeranjang(`Jumlah serial ${this.serialOptionName[element.type]} ${element.product_code} harus ${element.max_qty}`)
							}
							if (index == this.dataSerial.length-1 && !this.alertKeranjang) {
								this.step_up()
							}
						});
					} else {
						this.step_up()
					}
				}
			}
		},
		validateCart(){
			this.cart.forEach( (element, index) => {
				if (parseInt(element.quantity) > parseInt(element.stock_pos)) {
					this.setAlertKeranjang(`Jumlah ${element.product_name} Melebihi Stok`)
				}
				if (index == this.cart.length-1 && !this.alertKeranjang) {
					this.step_up()
				}
			});
		},
		validateData(){
			return new Promise( async (resolve) => {
				if (!this.registrationData.mitra_code) {
					this.alert.mitra_code = "Data tidak boleh kosong"
				} else {
					this.alert.mitra_code = ""
					this.getmitraMLM({
						member_network_mid: this.registrationData.mitra_code
					}).then( () => {
						if (!this.mitraMLM.status) {
							this.alert.mitra_code = 'Kode Mitra tidak ditemukan'
						}
					})
				}
				if (!this.registrationData.email) {
					this.alert.email = "Data tidak boleh kosong"
				} else if (!validator.isEmail(this.registrationData.email)) {
					this.alert.email = "Email tidak valid"
				} else {
					this.alert.email = ""
				}
				if (!this.registrationData.name) {
					this.alert.name = "Data tidak boleh kosong"
				} else {
					if (this.registrationData.name.length < 3) {
						this.alert.name = "Nama terlalu pendek"
					} else {
						this.alert.name = ""
					}
				}
				if (!this.registrationData.card_id) {
					this.setAlertMandatory({type:'ktp', data: "Data tidak boleh kosong"})
				} else if (!validator.isLength(this.registrationData.card_id , {min:16 , max:16})) {
					this.setAlertMandatory({type:'ktp', data: "KTP tidak valid"})
				} else {
					await this.checkMandatory({type:'ktp', data: this.registrationData.card_id})
				}
				if (!this.registrationData.mobilephone) {
					this.setAlertMandatory({type:'hp', data: "Data tidak boleh kosong"})
				} else if (!validator.isLength(this.registrationData.mobilephone , {min:10 , max:15})) {
					this.setAlertMandatory({type:'hp', data: "Nomor tidak valid"})
				} else {
					await this.checkMandatory({type:'hp', data: this.registrationData.mobilephone})
				}
				resolve()
			})
		},
		cekQty(index){
			if (parseInt(this.cart[index].quantity) > parseInt(this.cart[index].stock_pos) ) {
				this.setAlertKeranjang(`Jumlah ${this.cart[index].product_name} Melebihi Stok`)
				this.cart[index].quantity = this.cart[index].stock_pos
				this.changeCartQty({
					type: '',
					index: index
				})
			} else {
				this.changeCartQty({
					type: '',
					index: index
				})
			}
		},
		minQty(index){
			this.changeCartQty({
				type: 'min',
				index: index
			})
		},
		addQty(index){
			this.changeCartQty({
				type: 'plus',
				index: index
			})
		},
		confirmBayar(){
			//this.setConfirmPaymentMessage(`Apakah anda yakin akan melakukan transaksi ini ?`)
			this.setShowModalPin(true)
		},
		bayar(){
			this.setConfirmPaymentMessage(``)
			if (!this.selectedPayment.value) {
				this.setAlertKeranjang(`Silahkan Pilih Metode Pembayaran`)
			} else {
				// let price_total = this.price_total
				let product = [... this.dataProduct]
				
				// if (!this.mitra || this.register) {
					// 	price_total = price_total + this.registerItem.price_total
					// }
					// if (this.payTotal <= 0) {
						// 	this.setAlertKeranjang(`Mohon masukkan nominal pembayaran`)
						// } else if (!(this.payTotal.replace(/\D/g, "") >= price_total)) {
							// 	this.setAlertKeranjang(`Nominal yang dibayarkan kurang dari total harga`)
							// } else {
								//console.log(this.register)
								
					if (!this.mitra) {
						let indexRegister = product.findIndex(element => element.product_code == this.registerItem.code)
						let serialRegister = this.dataSerial.find(element => element.product_code == this.registerItem.code)

						//console.log(indexRegister)
						//console.log(serialRegister)

						if (indexRegister == -1) {
							let product_register = {
								product_code: this.registerItem.code,
								product_id: this.registerItem.id,
								product_name: this.registerItem.name,
								product_price: this.registerItem.price,
								product_weight: this.registerItem.weight,
								quantity: serialRegister.max_qty,
								//serial: serialRegister.serial
							}
							
							product_register.serial = []
							product_register.serial[serialRegister.type] = serialRegister.serial

							product.push(product_register)

							//console.log(product)
						} else {
							product[indexRegister].quantity = serialRegister.max_qty
						}
					}
					var params = {}
					if (this.register) {
						params = {
							buyer_sponsor_network_mid: this.mitraMLM.network_mid.toUpperCase(),
							email: this.registrationData.email,
							name: this.registrationData.name,
							mobilephone: this.registrationData.mobilephone,
							payment_method: this.selectedPayment.value,
							product: product
						}
						this.postTransactionRegister(params)
						//console.log('Register ...')
						//console.log(params)
					} else {
						if (this.mitra) {
							let prospectiveMemberStatus = this.prospectiveMitra.transactionType == 'member' ? 'member' : 'nonmember';
							params = {
								member_network_mid: this.mitraMLM.network_mid.toUpperCase(),
								payment_method: this.selectedPayment.value,
								product: product,
								serial_type: this.serialType,
								serial_digital_bv: this.serialDigitalToSell,
								member_status: prospectiveMemberStatus,
								prospective_member_name: this.prospectiveMitra.name,
								prospective_member_mobilephone: this.prospectiveMitra.mobilephone,
							}
							this.postTransactionMitra(params)
							//console.log('Mitra ...')
							//console.log(params)
						} else {
							params = {
								// passwd: this.registrationData.password,
								// passwd2: this.registrationData.repassword,
								name: this.registrationData.name,
								email: this.registrationData.email,
								// address: this.registrationData.address,
								// province: this.registrationData.province.area_id,
								// province_name: this.registrationData.province.area_name,
								// city: this.registrationData.city.area_id,
								// city_name: this.registrationData.city.area_name,
								// zipcode: this.registrationData.zipcode,
								// birthdate: this.registrationData.borndate,
								// birthplace: this.registrationData.bornplace,
								// gender: this.registrationData.gender,
								identity_no: this.registrationData.card_id,
								mobilephone: this.registrationData.mobilephone,
								buyer_sponsor_network_mid: this.mitraMLM.network_mid.toUpperCase(),
								payment_method: this.selectedPayment.value,
								product: product,
								// identity_type: this.registrationData.,
								// mobilephone: this.registrationData.phone,
								// phone: this.registrationData.phone,
								serial_type: this.serialType,
								serial_digital_bv: this.serialDigitalToSell,
							}
							this.postTransactionNonMitra(params)
							//console.log('Non Mitra ...')
							//console.log(params)
						}
					}
				// }

			}
		}
	},
	watch: {
		mandatoryError: {
			deep:true,
			handler: function (val) {
				if (!this.mitra) {
					this.alert.card_id = val.ktp
					this.alert.mobilephone = val.hp
				}
			}
		}
	}
};
</script>

<style scoped>
</style>
